import { useEffect, useState, useMemo } from "react";
import Top from "./Top";
import Right from "./Right";
import { getUserFromToken } from "../../function";
import { server } from "../../server";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import html2pdf from "html2pdf.js";

function Payments() {
  const dispatch = useDispatch();
  const token = localStorage.getItem("authToken");
  const user = useMemo(() => getUserFromToken(), []);
  const userId = user?.userObjectId || user?._id || user?.sub;
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const generateInvoice = (payment) => {
    const element = document.createElement("div");

    element.innerHTML = `
      <div style="font-family: Arial, sans-serif; padding: 30px; color:#333;">

        <!-- HEADER -->
        <div style="display:flex; justify-content:space-between; align-items:center;">
          <div>
            <img src="/assets/images/pdf-logo.png" style="height:50px;" />
            <p style="margin:0; margin-top: 20px; font-size:12px; color:#666;">
              CIN : U98200MH2024PTC425556
            </p>
            <p style="margin:2px 0; font-size:12px; color:#666; line-height: 0.2 !important;">
              support@visualaey.com
            </p>
          </div>

          <div style="text-align:right;">
            <h1 style="margin:0; letter-spacing:2px;">INVOICE</h1>
            <p style="margin:5px 0; font-size:12px;">
              <strong>ID:</strong> ${payment.paymentId}<br/>
              <strong>Date:</strong> ${new Date(payment.paidAt).toLocaleDateString()}
            </p>
          </div>
        </div>

        <!-- DIVIDER -->
        <hr style="margin:20px 0;" />

        <!-- CUSTOMER + PAYMENT -->
        <div style="display:flex; justify-content:space-between;">

          <!-- Customer -->
          <div>
            <h4 style="margin-bottom:5px;">Billed To</h4>
            <p style="margin:0; font-size:13px; line-height: 1.2 !important;">
              Name: ${user.name}<br />
              Email Address: ${user.email}<br />
              Phone No: ${user.phone}
            </p>
          </div>

          <!-- Payment Info -->
          <div style="text-align:right;">
            <h4 style="margin-bottom:5px;">Payment Details</h4>
            <p style="margin:0; font-size:13px;">
              Status: <strong style="color:${
                payment.status === "paid" ? "green" : "orange"
              }">${payment.status}</strong><br/>
              Currency: ${payment.currency || "INR"}
            </p>
          </div>

        </div>

        <!-- TABLE -->
        <table style="width:100%; margin-top:25px; border-collapse:collapse;">
          <thead>
            <tr style="background:#f5f5f5;">
              <th style="text-align:left; padding:10px; border:1px solid #ddd;">Description</th>
              <th style="text-align:right; padding:10px; border:1px solid #ddd;">Amount</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td style="padding:10px; border:1px solid #ddd; line-height: 1.2 !important;">
                ${payment.membershipDetails?.plan || "N/A"} Plan
                <br />
                ${payment.membershipDetails?.planDescription || "—"}
                <br/>
                <br/>
                ${
                  payment.membershipDetails?.eventLimit
                    ? `Events: ${payment.membershipDetails.eventLimit}<br />Photos: ${payment.membershipDetails.photoLimit}`
                    : ""
                }
              </td>

              <td style="padding:10px; text-align:right; border:1px solid #ddd;">
                ₹${payment.amount || 0}
              </td>
            </tr>
          </tbody>
        </table>

        <!-- TOTAL SECTION -->
        <div style="margin-top:20px; display:flex; justify-content:flex-end;">
          <div style="width:250px;">
            <div style="display:flex; justify-content:space-between; font-size:14px;">
              <span>Subtotal</span>
              <span>₹${payment.amount || 0}</span>
            </div>

            <div style="display:flex; justify-content:space-between; font-size:14px;">
              <span>Tax</span>
              <span>₹0</span>
            </div>

            <hr/>

            <div style="display:flex; justify-content:space-between; font-size:16px; font-weight:bold;">
              <span>Total</span>
              <span>₹${payment.amount || 0}</span>
            </div>
          </div>
        </div>

        <!-- FOOTER -->
        <div style="margin-top:50px; font-size:12px; color:#777; text-align:center; line-height: 1.2 !important;">
          <p style="margin:0px;">Thank you for your purchase 🙌</p>
          <p>This is a system generated invoice. No signature required.</p>
        </div>

      </div>
    `;

    html2pdf()
      .set({
        margin: 10,
        filename: `Invoice_${payment.paymentId}.pdf`,
        image: { type: "jpeg", quality: 1 },
        html2canvas: {
          scale: 4,
          useCORS: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
      })
      .from(element)
      .save();
  };

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const response = await fetch(
          `${server}/Payment/GetPaymetByUserObjectId?userObjectId=${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const data = await response.json();

        setPayments(data.payments || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (userId && token) fetchPayments();
  }, [userId, token]); // ✅ no loop now

  return (
    <main>
      <Top />

      <div className="container">
        <div className="row g-3">
          <div className="col-lg-9 col-12 py-2">
            <section class="position-relative z-1">
              <div className="pb-3 d-flex flex-column flex-md-row gap-0 align-items-md-center justify-content-between">
                <div className="d-flex align-items-center">
                  <Link
                    to="/all-events"
                    className="action-button-md bg-white-transparent rounded-circle"
                  >
                    <i className="bi bi-arrow-left fs-4 text-dark"></i>
                  </Link>
                  <div>
                    <h1 className="mb-0 h4 text-light lh-1 fw-medium ms-3">
                      Payment History
                    </h1>
                    <nav aria-label="breadcrumb" className="m-0 ms-3">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <span>Home</span>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                        >
                          Payments
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </section>

            <div className="bg-white p-5 pb-0 rounded-4">
              {loading ? (
                <div className="spinner-border spinner-border-sm mb-5" />
              ) : error ? (
                <p className="text-danger">{error}</p>
              ) : payments.length === 0 ? (
                <p>No payments found</p>
              ) : (
                <>
                  <span className="text-primary d-block text-uppercase fw-semibold ls-lg fs-6 mb-3">
                    Payment History
                  </span>

                  {payments.map((payment, i) => (
                    <div
                      key={i}
                      className={`mb-4 pb-3 ${
                        i !== payments.length - 1 ? "border-bottom" : ""
                      }`}
                    >
                      <h6 className="fw-semibold text-uppercase text-muted mb-1 lh-1">
                        {payment.membershipDetails?.category || "Payment"}
                      </h6>

                      <h3 className="fw-semibold mb-2 lh-sm">
                        {payment.membershipDetails?.plan || "N/A"} Plan
                      </h3>

                      <p className="fs-5 text-muted mb-2 lh-1">
                        {payment.membershipDetails?.planDescription || "—"}
                      </p>

                      <p className="fs-5 text-dark mb-1 lh-sm">
                        💰 Amount — ₹{payment.amount || "N/A"}
                        <br />
                        📦 Status —{" "}
                        <span
                          className={
                            payment.status === "paid"
                              ? "text-success"
                              : "text-warning"
                          }
                        >
                          {payment.status}
                        </span>
                        <br />
                        🆔 Payment ID — {payment.paymentId}
                      </p>

                      {/* Optional details if exist */}
                      {payment.membershipDetails?.eventLimit && (
                        <p className="fs-5 text-dark mb-1 lh-sm">
                          Events Limit — {payment.membershipDetails.eventLimit}
                          <br />
                          Photos Limit —{" "}
                          {payment.membershipDetails.photoLimit?.toLocaleString(
                            "en-IN",
                          )}
                        </p>
                      )}

                      <p className="fs-6 text-muted mb-0">
                        Paid on {new Date(payment.paidAt).toLocaleDateString()}{" "}
                        &nbsp;{new Date(payment.paidAt).toLocaleTimeString()}
                      </p>

                      <span
                        onClick={() => generateInvoice(payment)}
                        className="btn btn-dark my-3 btn-sm px-4 rounded-pill"
                      >
                        Download Invoice
                      </span>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>

          <div className="col-lg-3 col-12">
            <Right />
          </div>
        </div>
      </div>
    </main>
  );
}

export default Payments;
